import { c as _c } from "react/compiler-runtime";
import { Dotors, HospitailLocation, HospitailTreatmentInfo, HospitalImages, HospitalIntroduction } from '@/widgets/hospital/ui/organisms';
import { PartnerHospitalEquipment, PartnerHospitalOperation } from '@/entities/hospital/api/types';
import { BannerTreatmentCase, PartnerHospitalTabs } from '@/widgets/hospital/ui/molecules';
import { NoDataTemplates } from '@/shared/ui/templates';
interface HospitalTabContentProps {
  partnerHospital?: PartnerHospitalOperation;
  address: string;
  location: {
    latitude: number;
    longitude: number;
  };
  equipments: PartnerHospitalEquipment[];
  isPartner: boolean;
}
const HospitalTabContent = t0 => {
  const $ = _c(26);
  const {
    partnerHospital,
    address,
    location,
    equipments,
    isPartner
  } = t0;
  let t1;
  if ($[0] !== partnerHospital) {
    t1 = partnerHospital ?? {};
    $[0] = partnerHospital;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    detailImages: imageList,
    introduction,
    doctors,
    hospitalOriginId,
    parkingInformation,
    uninsuredItems: t2
  } = t1;
  let t3;
  if ($[2] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const uninsuredItems = t3;
  const t4 = location?.latitude || 0;
  const t5 = location?.longitude || 0;
  let t6;
  if ($[4] !== address || $[5] !== parkingInformation || $[6] !== t4 || $[7] !== t5) {
    t6 = {
      address,
      parkingGuide: parkingInformation,
      latitude: t4,
      longitude: t5
    };
    $[4] = address;
    $[5] = parkingInformation;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const locationProps = t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <PartnerHospitalTabs />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== doctors || $[11] !== hospitalOriginId || $[12] !== imageList || $[13] !== introduction?.introduction || $[14] !== isPartner || $[15] !== partnerHospital) {
    t8 = isPartner && partnerHospital ? <><HospitalImages imageList={imageList ?? []} /><HospitalIntroduction introduction={introduction?.introduction ?? ""} /><Dotors doctors={doctors ?? []} hospitalOriginId={hospitalOriginId ?? 0} /></> : <div className="flex flex-col gap-[112px] items-center justify-center mt-[80px] mb-[80px] px-4"><NoDataTemplates pageName="hospitalInfo" priority={true} /><BannerTreatmentCase /></div>;
    $[10] = doctors;
    $[11] = hospitalOriginId;
    $[12] = imageList;
    $[13] = introduction?.introduction;
    $[14] = isPartner;
    $[15] = partnerHospital;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== locationProps) {
    t9 = <HospitailLocation location={locationProps} />;
    $[17] = locationProps;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== equipments || $[20] !== uninsuredItems) {
    t10 = (equipments.length > 0 || uninsuredItems.length > 0) && <HospitailTreatmentInfo uninsuredItems={uninsuredItems} equipments={equipments} />;
    $[19] = equipments;
    $[20] = uninsuredItems;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t8 || $[24] !== t9) {
    t11 = <div>{t7}{t8}{t9}{t10}</div>;
    $[22] = t10;
    $[23] = t8;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
};
export default HospitalTabContent;